export default class Dropdown {
    constructor(element) {
        this.element = element;
        this.toggle = this.element.querySelector('.dropdown__button')
        this.list = this.element.querySelector('.dropdown__list')
        this.listItems = this.list.querySelectorAll('li')
        this.input = this.element.querySelector('input')
        if (this.element === undefined
            || this.toggle === undefined
            || this.list === undefined
            || this.listItems === undefined
            || this.input === undefined) {
            throw 'Dropdown markup not complete'
        }
        this.prepareInput()
        this.setValidState()
    }

    prepareInput() {
        this.toggle.addEventListener('click', () => {
            this.toggleDropdown()
        })
        for (let i = 0; i < this.listItems.length; i++) {
            this.listItems[i].addEventListener('click', () => {
                this.selectOption(this.listItems[i])
                this.toggleDropdown()
            })
        }
        document.addEventListener('keydown', (event) => {
            if (event.key === "Escape" && !this.list.hidden) {
                this.toggleDropdown();
            }
        });
    }

    setValidState() {
        if (!this.input.hasAttribute("required")) {
            return;
        }

        if (this.input.value === "") {
            return this.element.setAttribute("aria-invalid", "true");
        }

        this.element.removeAttribute("aria-invalid");
    }

    toggleDropdown() {
        this.list.hidden = !this.list.hidden
    }

    selectOption(element) {
        let value = element.getAttribute("value");

        this.toggle.value = value
        this.input.value = value
        this.toggle.innerText = element.innerText
        this.setValidState()
    }
}
